/* MAXIM · Formularios propios conectados a KLAVIYO
   - Newsletter: sustituye el embed de Klaviyo (UsUtgh) y suscribe a la lista WuFGcU (doble opt-in)
   - Kontakt / B2B / Maschinen: envían la consulta a Klaviyo como evento (flow «Kontaktanfragen Website» avisa a info@coffee-maxim.com) */
(function () {
  var COMPANY = 'VQHpx2', LIST = 'WuFGcU';
  var lang = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
  var T = {
    de: { ph: 'Deine E-Mail-Adresse', btn: 'Anmelden', ok: 'Fast geschafft! Bitte bestätige deine Anmeldung in deinem Postfach.', err: 'Das hat leider nicht geklappt. Bitte versuche es noch einmal.', bad: 'Bitte gib eine gültige E-Mail-Adresse ein.' },
    es: { ph: 'Tu correo electrónico', btn: 'Suscribirme', ok: '¡Casi listo! Confirma tu suscripción en tu bandeja de entrada.', err: 'No ha funcionado. Inténtalo de nuevo, por favor.', bad: 'Introduce un correo electrónico válido.' },
    en: { ph: 'Your email address', btn: 'Subscribe', ok: 'Almost done! Please confirm your subscription in your inbox.', err: 'Something went wrong. Please try again.', bad: 'Please enter a valid email address.' }
  };
  var t = T[lang] || T.de;

  function build(host) {
    if (host.getAttribute('data-mx-nl')) return;
    host.setAttribute('data-mx-nl', '1');
    host.className = 'mx-nl';
    host.innerHTML =
      '<form class="mx-nl__form" novalidate>' +
        '<input class="mx-nl__in" type="email" name="email" autocomplete="email" required placeholder="' + t.ph + '" aria-label="' + t.ph + '">' +
        '<input class="mx-nl__hp" type="text" name="website" tabindex="-1" autocomplete="off" aria-hidden="true">' +
        '<button class="mx-nl__btn" type="submit">' + t.btn + '</button>' +
      '</form><p class="mx-nl__msg" role="status" aria-live="polite"></p>';
    var form = host.querySelector('form'), input = host.querySelector('.mx-nl__in'),
        btn = host.querySelector('.mx-nl__btn'), msg = host.querySelector('.mx-nl__msg');
    function say(text, ok) { msg.textContent = text; msg.className = 'mx-nl__msg ' + (ok ? 'mx-nl__msg--ok' : 'mx-nl__msg--err'); }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.website.value) return; /* bot */
      var email = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { say(t.bad, false); input.focus(); return; }
      btn.disabled = true;
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: 'Website Newsletter (' + lang.toUpperCase() + ')',
          profile: { data: { type: 'profile', attributes: { email: email, properties: { Sprache: lang } } } }
        }, relationships: { list: { data: { type: 'list', id: LIST } } } } })
      }).then(function (r) {
        if (r.ok || r.status === 202) { form.style.display = 'none'; say(t.ok, true); }
        else { btn.disabled = false; say(t.err, false); }
      }).catch(function () { btn.disabled = false; say(t.err, false); });
    });
  }


  /* ---------- Kontakt / B2B / Maschinen → Klaviyo ---------- */
  var NET = { de: 'Das hat leider nicht geklappt. Bitte versuchen Sie es noch einmal oder schreiben Sie an info@coffee-maxim.com.', es: 'No ha funcionado. Inténtalo de nuevo o escríbenos a info@coffee-maxim.com.', en: 'Something went wrong. Please try again or email info@coffee-maxim.com.' };
  function contact(form) {
    if (form.getAttribute('data-mx-ready')) return;
    form.setAttribute('data-mx-ready', '1');
    var wrap = form.parentNode, ok = wrap.querySelector('.mx-cf__ok'), err = form.querySelector('.mx-cf__err'),
        btn = form.querySelector('.mx-cf__btn');
    function showErr(t) { err.textContent = t; err.hidden = false; }
    function val(n) { var f = form.elements[n]; return f ? (f.value || '').trim() : ''; }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      err.hidden = true;
      if (val('website')) return; /* bot */
      var bad = false;
      [].forEach.call(form.querySelectorAll('[required]'), function (f) {
        var v = f.type === 'checkbox' ? f.checked : (f.value || '').trim();
        if (f.type === 'email' && v) v = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
        f.classList.toggle('mx-cf__in--bad', !v); if (!v) bad = true;
      });
      if (bad) { showErr(form.getAttribute('data-mx-err')); return; }
      var name = val('name'), parts = name.split(/\s+/),
          company = val('company'), email = val('email');
      btn.disabled = true;
      fetch('https://a.klaviyo.com/client/events/?company_id=' + COMPANY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'event', attributes: {
          metric: { data: { type: 'metric', attributes: { name: 'Form submitted by profile' } } },
          properties: {
            mx_source: 'maxim-website-kontakt',
            Formular: form.getAttribute('data-mx-subject'),
            Typ: form.getAttribute('data-mx-cf'),
            Name: name, Firma: company, Telefon: val('phone'),
            Nachricht: val('message'), Sprache: lang,
            Seite: location.href.split('?')[0],
            Datenschutz: 'akzeptiert ' + new Date().toISOString()
          },
          profile: { data: { type: 'profile', attributes: {
            email: email, first_name: parts[0] || '', last_name: parts.slice(1).join(' '),
            organization: company || undefined,
            properties: { Sprache: lang, 'Letzte Anfrage': form.getAttribute('data-mx-subject') }
          } } }
        } } })
      }).then(function (r) {
        if (r.ok || r.status === 202) { form.hidden = true; ok.hidden = false; ok.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        else { btn.disabled = false; showErr(NET[lang] || NET.de); }
      }).catch(function () { btn.disabled = false; showErr(NET[lang] || NET.de); });
    });
  }

  function run() {
    var cfs = document.querySelectorAll('form[data-mx-cf]');
    for (var j = 0; j < cfs.length; j++) contact(cfs[j]);
    var hosts = document.querySelectorAll('.klaviyo-form-UsUtgh');
    for (var i = 0; i < hosts.length; i++) build(hosts[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
